export default __webpack_public_path__ + "static/media/caretaker.fed17dbe.jpg";